"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _NavigationBar = require("./NavigationBar");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var Navigation = function Navigation(_ref) {
  var className = _ref.className,
    children = _ref.children,
    ariaLabel = _ref.ariaLabel,
    containerId = _ref.containerId;
  var childrenRef = (0, _react.useRef)([]);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    navIndex = _useState2[0],
    setNavIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focusHandlerEnabled = _useState4[0],
    setFocusHandlerEnabled = _useState4[1];
  var childrenCount = _react["default"].Children.count(children);
  var maxIndex = childrenCount - 1;
  (0, _react.useEffect)(function () {
    if (focusHandlerEnabled && childrenRef.current[navIndex]) {
      childrenRef.current[navIndex].focus();
    }
  }, [navIndex]);
  (0, _react.useEffect)(function () {
    childrenRef.current = new Array(childrenCount);
    // Prevent focus on initial render
    setFocusHandlerEnabled(true);
  }, []);
  var setIndex = function setIndex(index) {
    if (index > maxIndex) {
      setNavIndex(0);
    } else if (index < 0) {
      setNavIndex(maxIndex);
    } else {
      setNavIndex(index);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    var key = event.key;
    switch (key) {
      case 'ArrowRight':
        setIndex(navIndex + 1);
        break;
      case 'ArrowLeft':
        setIndex(navIndex - 1);
        break;
      case 'Home':
        setIndex(0);
        break;
      case 'End':
        setIndex(maxIndex);
        break;
      default:
        break;
    }
  };
  return /*#__PURE__*/_react["default"].createElement("nav", {
    "aria-label": ariaLabel,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_NavigationBar.NavigationBarContainer, {
    role: "menubar",
    id: containerId,
    "aria-label": ariaLabel,
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/_react["default"].createElement(_NavigationBar.NavigationBarItems, {
    childrenRef: childrenRef,
    navIndex: navIndex
  }, children)));
};
Navigation.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  containerId: _propTypes["default"].string
} : {};
Navigation.defaultProps = {
  ariaLabel: 'QuintoAndar, navegação',
  containerId: 'menubar'
};
var _default = exports["default"] = Navigation;